import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueI18n from 'vue-i18n';
import enMessages from './locales/en';
import zhHkMessages from './locales/zh-hk';
import zhCnMessages from './locales/zh-cn'

Vue.use(Vuetify)
Vue.use(VueI18n);

const messages = {
  en: enMessages,
  'zh-hk': zhHkMessages,
  'zh-cn': zhCnMessages,
};

const i18n = new VueI18n({
  locale: document.documentElement.lang, // Default locale
  messages,
});


new Vue({
  el: '#calendar',
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi', // Ensure that the iconfont is set to 'mdi'
    },
    theme: {
      primary: '#3f51b5'
    }
  }),
  i18n, // Add Vue I18n to Vue instance
  mounted() {
    // Watch for changes in the HTML lang attribute and update the locale accordingly
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'lang') {
          this.$i18n.locale = mutation.target.lang;
        }
      });
    });
    observer.observe(document.getElementById('html-tag'), { attributes: true });
  },
  render: h => h(App)
})